import { render, staticRenderFns } from "./companyStoreCommission.vue?vue&type=template&id=15cb991c&"
import script from "./companyStoreCommission.vue?vue&type=script&lang=js&"
export * from "./companyStoreCommission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports